<template>
  <div :class="`${skinClass} ${$store.state.app.skin.dark ? 'is-dark' : ''}`">
    <div
      class="alert alert-info"
      role="alert"
      v-if="deferredPrompt"
      style="
        position: fixed;
        bottom: 0;
        z-index: 999999;
        width: 100%;
        background: rgb(204 241 246 / 80%);
        text-align: center;
      "
    >
      <h4 class="alert-heading">Динамик платформ апп!</h4>
      <p>Та Динамик платформ апп суулгах уу?.</p>
      <hr />
      <div class="mb-0">
        <button type="button" class="mr-1 btn btn-primary" @click="install">
          Суулгах
        </button>
        <button type="button" class="btn btn-light" @click="dismiss">
          Үгүй
        </button>
      </div>
    </div>
    <div v-bind:class="[ioszaawar ? 'iosTutorial' : '']">
      <div
        class="alert alert-info"
        role="alert"
        v-if="onlyIphone"
        style="
          position: fixed;
          bottom: 0;
          z-index: 999999;
          width: 100%;
          background: rgb(204 241 246 / 80%);
          text-align: center;
        "
      >
        <h4 class="alert-heading">Динамик платформ апп!</h4>
        <p>Та Динамик платформ апп суулгах уу?.</p>
        <hr />
        <div class="mb-0">
          <button type="button" class="mr-1 btn btn-primary" @click="showIOS">
            Суулгах
          </button>
          <button type="button" class="btn btn-light" @click="hideIOS">
            Үгүй
          </button>
        </div>
      </div>
      <div v-if="ioszaawar">
        <button
          type="button"
          class="btn btn-danger iosClose"
          @click="closeTutorial"
        >
          Хаах
        </button>
        <b-carousel
          class="loc-type-carousel"
          :interval="4000"
          controls
          indicators
        >
          <!-- Slides with image only -->
          <!-- <b-carousel-slide v-for="(t,i) in tasks" :key="i" :img-src="`${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop`"></b-carousel-slide> -->
          <!-- <div class="loc-type-carousel-image" v-for="(t,i) in tasks" :key="i" :style="`background: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`"></div> -->
          <b-carousel-slide class="zaawar">
            <template #img>
              <!-- <div style="height: 600px !important"
              class="d-block img-fluid w-100"
              :style="`background-image: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`"
              alt="image slot"
              ></div>-->
              <div
                class="loc-type-carousel-image"
                style="background: url(assets/img/z1.jpg)"
              ></div>
            </template>
          </b-carousel-slide>
          <b-carousel-slide class="zaawar">
            <template #img>
              <!-- <div style="height: 600px !important"
              class="d-block img-fluid w-100"
              :style="`background-image: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`"
              alt="image slot"
              ></div>-->
              <div
                class="loc-type-carousel-image"
                style="background: url(assets/img/z2.jpg)"
              ></div>
            </template>
          </b-carousel-slide>
          <b-carousel-slide class="zaawar">
            <template #img>
              <!-- <div style="height: 600px !important"
              class="d-block img-fluid w-100"
              :style="`background-image: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`"
              alt="image slot"
              ></div>-->
              <div
                class="loc-type-carousel-image"
                style="background: url(assets/img/z3.jpg)"
              ></div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>

    <aside
      v-if="$store.state.app.mainLayoutConfig.aside"
      class="aside aside-fixed"
      :class="{
        minimize: $store.state.app.aside.minimize,
        maximize: $store.state.app.aside.maximize,
        'aside-filemgr': $store.state.app.aside.filemgr,
      }"
      @mouseover="
        changeAside(
          $store.state.app.aside.minimize,
          $store.state.app.aside.minimize ? true : false
        )
      "
      @mouseleave="changeAside($store.state.app.aside.minimize, false)"
    >
      <div class="aside-header">
        <router-link
          v-if="$store.state.app.activeGroup.id == 9164"
          to="/"
          class="aside-logo"
        >
          ЗХУТ<span></span>
        </router-link>
        <router-link v-else to="/" class="aside-logo">
          Dynamic <span>4.0</span>
        </router-link>
        <!-- <a @click.stop="changeAside(!$store.state.app.aside.minimize, $store.state.app.aside.maximize)" class="aside-menu-link"> -->
        <a
          @click.stop="
            changeAside(
              !$store.state.app.aside.minimize,
              $store.state.app.aside.maximize ? false : false
            );
            mainMenuOpen();
          "
          class="aside-menu-link"
        >
          <feather
            :type="
              $store.state.app.aside.minimize ? 'arrow-right' : 'arrow-left'
            "
          ></feather>
        </a>
      </div>
      <vue-custom-scrollbar
        class="aside-body"
        style="height: calc(100vh - 59px)"
        @mouseenter="asideEnter"
      >
        <div class="aside-loggedin">
          <div class="d-flex align-items-center justify-content-start">
            <a href="javascript: void(0)" class="avatar">
              <img
                :src="$store.state.user.userInfo.avator"
                class="rounded-circle"
                alt
              />
            </a>
            <div class="aside-alert-link">
              <a
                @click="$router.push({ name: 'notification' })"
                role="button"
                :class="{ new: tasksCountUnseen > 0 }"
                data-toggle="tooltip"
                :title="
                  'Идэвхтэй ' +
                    tasksCount +
                    ' ажилбар, үзээгүй ' +
                    tasksCountUnseen +
                    ' ажилбар байна'
                "
              >
                <feather type="bell" size="16"></feather>
              </a>
              <a
                @click="logout"
                data-toggle="tooltip"
                role="button"
                title="Гарах"
              >
                <feather type="log-out" size="16"></feather>
              </a>
            </div>
          </div>
          <div class="aside-loggedin-user">
            <a
              href="#loggedinMenu"
              class="d-flex align-items-center justify-content-between mg-b-2"
              data-toggle="collapse"
            >
              <h6 class="tx-semibold mg-b-0">
                {{ $store.state.user.userInfo.fullName }}
              </h6>
              <feather type="chevron-down" size="16"></feather>
            </a>
            <p class="tx-color-03 tx-12 mg-b-0">
              {{ $store.state.user.userInfo.position }}
            </p>
          </div>
          <div
            class="collapse"
            id="loggedinMenu"
            :class="{ show: $route.name == 'settings' }"
          >
            <ul class="nav nav-aside mg-b-0">
              <!-- <li class="nav-item">
                <a href="javascript: void(0)" class="nav-link">
                  <feather type="edit" size="16"></feather>
                  <span>Мэдээлэл шинэчлэх</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link">
                  <feather type="user" size="16"></feather>
                  <span>Хувийн мэдээлэл</span>
                </a>
              </li>-->
              <li
                class="nav-item"
                :class="{ active: $route.name == 'settings' }"
              >
                <a
                  v-show="$store.state.app.activeGroup.id != 9249"
                  @click="
                    $router.push({ name: 'settings', params: { mode: '2' } })
                  "
                  role="button"
                  class="nav-link"
                >
                  <feather type="settings" size="16"></feather>
                  <span>Тохиргоо</span>
                </a>
                <a
                  v-show="$store.state.app.activeGroup.id == 9249"
                  @click="
                    $router.push({ name: 'settings', params: { mode: '3' } })
                  "
                  role="button"
                  class="nav-link"
                >
                  <feather type="settings" size="16"></feather>
                  <span>Тохиргоо</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  :href="$store.state.app.activeGroup.helpPageUrl"
                  target="_blank"
                  class="nav-link"
                >
                  <feather type="help-circle" size="16"></feather>
                  <span>Гарын авлага</span>
                </a>
              </li>
              <li class="nav-item">
                <a @click="logout" role="button" class="nav-link">
                  <feather type="log-out" size="16"></feather>
                  <span>Гарах</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- aside-loggedin -->
        <!-- {{isVet}}
        v-if="isVet" :key="isVetKey"-->
        <!-- <ul class="nav nav-aside">
          <li class="nav-label">Хүсэлтүүд</li>
          <li v-if="!menu.vet.meesbul" class="nav-item" :class="{'active': $route.name=='home'}"><a @click="$router.push({name: 'home'})" role="button" class="nav-link"><i data-feather="bar-chart-2"></i> <span>Статистик</span></a></li>
          <li v-if="(!menu.vet.meesbul) && (!menu.vet.pharma)" class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedSpecial'}"><a @click="turnToPage({name: 'vetMedSpecial', params: { ot: 468 } })" role="button" class="nav-link"><i data-feather="award"></i> <span class="lh-1">Тусгай зөвшөөрлийн <br />хүсэлтүүд</span></a></li>
          <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedListReq'}"><a @click="turnToPage({name: 'vetMedListReq', params: { ot: 465 } })" role="button" class="nav-link"><i data-feather="tag"></i> <span class="lh-1">Эм, бэлдмэл бүртгүүлэх<br />хүсэлтүүд</span></a></li>          
          <li v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)" class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedSample'}"><a @click="turnToPage({name: 'vetMedSample', params: { ot: 479 } })" role="button" class="nav-link"><i data-feather="droplet"></i> <span class="lh-1">Дээж импортлох <br />хүсэлтүүд</span></a></li>
          <li v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)" class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedLics'}"><a @click="turnToPage({name: 'vetMedLics', params: { ot: 467 } })" role="button" class="nav-link"><i data-feather="truck"></i> <span class="lh-1">Эм, бэлдмэл импортлох <br/>лицензийн хүсэлтүүд</span></a></li>          
          <template v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)">
            <li class="nav-label mg-t-25">Компани</li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedList'}"><a @click="turnToPage({name: 'vetMedList', params: { ot: 463 } })" role="button" class="nav-link"><i data-feather="layers"></i> <span>Компаниуд</span></a></li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedMy'}"><a @click="turnToPage({name: 'vetMedMy', params: { ot: 478 } })" role="button" class="nav-link"><i data-feather="award"></i> <span>Тусгай зөвшөөрөл</span></a></li>
          </template>
          
          <template v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)">
            <li class="nav-label mg-t-25">Бүртгэл</li>
            <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedAcceptedOrgLicences'}"><a @click="turnToPage({name: 'vetMedAcceptedOrgLicences', params: { ot: 476 } })" role="button" class="nav-link"><i data-feather="umbrella"></i> <span class="lh-1">Олгогдсон тусгай<br /> зөвшөөрлүүд</span></a></li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedMedicine'}"><a @click="turnToPage({name: 'vetMedMedicine', params: { ot: 472 } })" role="button" class="nav-link"><i data-feather="activity"></i> <span>Бүртгэлтэй эмүүд</span></a></li>
            <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedAcceptedSamples'}"><a @click="turnToPage({name: 'vetMedAcceptedSamples', params: { ot: 481 } })" role="button" class="nav-link"><i data-feather="octagon"></i> <span class="lh-1">Бүртгэлтэй<br /> дээжүүд</span></a></li>
            <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedAcceptedMeds'}"><a @click="turnToPage({name: 'vetMedAcceptedMeds', params: { ot: 477 } })" role="button" class="nav-link"><i data-feather="truck"></i> <span class="lh-1">Эм, бэлдмэл импортлох<br /> лиценз</span></a></li>                        
          </template>
          <template v-if="menu.vet.admin">
            <li class="nav-label mg-t-25">Хүний нөөц</li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedUsers'}"><a @click="turnToPage({name: 'vetMedUsers', params: { ot: 138 } })" role="button" class="text-muted nav-link"><i data-feather="users"></i> <span>Жагсаалт</span></a></li>
          </template>

          <li class="nav-label mg-t-25">Систем</li>
          <li class="nav-item" :class="{'active': $route.name=='mediaHome'}"><a @click="turnToPage({name: 'mediaHome' })" role="button" class="text-muted nav-link"><i data-feather="archive"></i> <span>Динамик драйв</span></a></li>
          <li v-if="!menu.vet.client" class="nav-item" :class="{'active': $route.name=='vidConference'}"><a @click="turnToPage({name: 'vidConference', params: { ot: 493 } })" role="button" class="nav-link"><i data-feather="video"></i> <span class="lh-1">Видео хурал</span></a></li>
          <li v-if="!menu.vet.client" class="nav-item" :class="{'active': $route.name=='sysReports'}"><a @click="turnToPage({name: 'sysReports', params: { ot: 451 } })" role="button" class="nav-link"><i data-feather="bar-chart-2"></i> <span class="lh-1">Тайлан мэдээ</span></a></li>
        </ul>-->
        <!-- <main-menu v-else /> -->
        <main-menu />
      </vue-custom-scrollbar>
    </aside>

    <!-- v-else-if="$route.meta.header==undefined && !isLms" -->

    <header
      v-else-if="myMobAppActiveGroup == 9233"
      class="navbar navbar-header navbar-header-fixed"
      :class="{ 'bd-b-0': $route.name == 'monicpa' }"
    >
      <a href="javascript: void(0)" id="mainMenuOpen" class="burger-menu">
        <feather type="menu"></feather>
      </a>
      <div class="navbar-brand" style="padding: 0">
        <a href="/" role="button">
          <img src="https://res.gosmart.mn/apps/vet.med/logo.png" />
        </a>
      </div>
      <div id="navbarMenu" class="navbar-menu-wrapper withicon">
        <div class="navbar-menu-header">
          <a href="#" class="df-logo">
            мал
            <span>эмнэлэг</span>
          </a>
          <a id="mainMenuClose" href="javascript: void(0)">
            <feather type="x"></feather>
          </a>
        </div>
        <ul class="nav navbar-menu">
          <li class="nav-label pd-l-15 pd-lg-l-25 d-lg-none">Үндсэн цэс</li>
          <li class="nav-item">
            <a href="/" class="nav-link" style="cursor: pointer">
              <feather type="home"></feather>Эхлэл
            </a>
          </li>
          <li
            class="nav-item"
            :class="{ active: $route.name == 'vetLandingMeds' }"
          >
            <a
              @click="turnToPage({ name: 'vetLandingMeds' })"
              class="nav-link"
              style="cursor: pointer"
            >
              <feather type="droplet"></feather>Бүртгэлтэй эм, бэлдмэл
            </a>
          </li>

          <li
            class="nav-item"
            :class="{ active: $route.name == 'vetLandingLics' }"
          >
            <a
              @click="turnToPage({ name: 'vetLandingLics' })"
              class="nav-link"
              style="cursor: pointer"
            >
              <feather type="box"></feather>Тусгай зөвшөөрөл
            </a>
          </li>
          <li class="nav-item">
            <a
              href="http://help.vetdrug.mn"
              target="_blank"
              class="nav-link"
              style="cursor: pointer"
            >
              <feather type="help-circle"></feather>Гарын авлага
            </a>
          </li>
          <li class="nav-item">
            <a
              href="http://help.vetdrug.mn/#/vet-landing-help/45047/1377723"
              target="_blank"
              class="nav-link"
            >
              <feather type="monitor"></feather>
              <span>Бүртгүүлэх</span>
            </a>
          </li>
        </ul>
      </div>
    </header>
    <header
      v-else-if="$store.state.app.mainLayoutConfig.header == 2"
      class="navbar navbar-header navbar-header-fixed"
    >
      <div class="container">
        <a
          id="mainMenuOpen"
          class="burger-menu mg-r-10"
          @click="mainMenuOpen()"
        >
          <feather type="menu" class="wd-30-f ht-30-f"></feather>
        </a>
        <div
          class="navbar-brand d-none d-md-inline"
          style="padding: 0; width: auto"
        >
          <router-link to="/" role="button" class="d-flex">
            <div>
              <img
                class="brand-logo"
                v-if="!$store.state.app.skin.dark"
                :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                :style="`width: 100%; max-width: ${getLgMxW()}`"
              />
              <img
                class="brand-logo"
                v-else
                :src="
                  `${myResBaseUrl}${
                    $store.state.app.activeGroup.logo.split('.')[0]
                  }-white.png`
                "
                :style="`width: 100%; max-width: ${getLgMxW()}`"
              />
              <span class="tx-normal mg-l-10">{{
                $store.state.app.activeGroup.name | stripHtml
              }}</span>
            </div>
            <div
              class="bd-l mg-l-10 pd-t-5"
              v-if="
                $store.state.app.activeGroup.id != 9241 &&
                  $store.state.app.activeGroup.id != 9249
              "
            >
              <img
                :src="
                  `${myResBaseUrl}/media/logo/v4${
                    $store.state.app.skin.dark ? '_white' : ''
                  }.png`
                "
                style="max-width: 110px"
                class="pd-l-10"
              />
            </div>
          </router-link>
        </div>
        <div id="navbarMenu" class="navbar-menu-wrapper withicon">
          <div class="navbar-menu-header">
            <template
              v-if="
                $store.state.app.activeGroup.id == 9241 ||
                  $store.state.app.activeGroup.id == 9249
              "
            >
              <router-link to="/" class="df-logo">
                Голомт
                <span>Академи</span>
              </router-link>
              <a id="mainMenuClose" @click="backdropClick()">
                <feather type="x"></feather>
              </a>
            </template>
            <template v-else>
              <router-link to="/" class="df-logo">
                Dynamic
                <span>Platform</span>
              </router-link>
              <a id="mainMenuClose" @click="backdropClick()">
                <feather type="x"></feather>
              </a>
            </template>
          </div>

          <div
            :class="
              `${
                $store.state.app.responsiveLayout.navbarNavShow
                  ? 'wd-100p pd-5'
                  : 'wd-60p'
              }`
            "
            v-if="$store.state.user.userId != ''"
          >
            <Autocomplete
              size="small"
              placeholder="Хайх утгаа бичнэ үү"
              v-model="courseState"
              popper-class="my-autocomplete"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              popper-append-to-body
              class="wd-100p"
            >
              <feather slot="append" :size="16" type="search"></feather>
              <template slot-scope="{ item }">
                <div class="lh-2">{{ item.value }}</div>
                <div class="progress ht-5 mg-t-5" v-if="item.isJoined">
                  <div
                    role="progressbar"
                    class="progress-bar"
                    :style="{ width: item.percent + '%' }"
                  ></div>
                </div>
                <div v-else class="text-muted text-lowercase tx-12 mg-t-5">
                  Сургалтад элсэх
                </div>
              </template>
            </Autocomplete>
          </div>

          <!-- <ul class="sidebar-nav lms-nav" >
            <li class="nav-item">
              <router-link to="/" class="nav-link">Эхлэл</router-link>
            </li>
          </ul>-->
          <ul
            class="nav navbar-menu"
            v-if="$store.state.app.responsiveLayout.navbarNavShow"
          >
            <li class="nav-label pd-l-20 pd-lg-l-25 d-lg-none">Цэс</li>
            <!-- is mobile lmsPages -->
            <div class="pd-x-5" v-if="hasLmsPages && $store.state.app.isMobile">
              <student-nav />
            </div>
            <!-- <li class="nav-item">
              <router-link to="/" class="nav-link">
                <feather type="home"></feather> Эхлэл
              </router-link>
            </li>-->
          </ul>
          <ul
            class=" sidebar-nav lms-nav pd-5 pos-absolute b-0 bd-t wd-100p bg-light"
            v-if="$store.state.app.isMobile"
          >
            <li class="nav-item">
              <router-link
                :to="{ name: 'lmsOffline' }"
                class="nav-link"
                :class="{ active: $route.name == 'lmsOffline' }"
              >
                <feather type="download"></feather>Оффлайн файлууд
                <div class="mg-l-auto badge badge-primary">
                  {{ $store.state.user.offlineAttaches }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>
        <div
          :class="`navbar-right ${$store.state.app.isMobile ? 'mg-r-20' : ''} `"
          v-if="$store.state.user.userId != ''"
          style="white-space: nowrap"
        >
          <header-bar-notification></header-bar-notification>
          <header-bar-localmail></header-bar-localmail>
          <div :class="`dropdown dropdown-profile`">
            <a href class="dropdown-link" data-toggle="dropdown">
              <div class="avatar avatar-sm mg-r-10">
                <img
                  :src="`${$store.state.user.userInfo.avator}`"
                  class="rounded-circle"
                  alt
                />
              </div>
              {{ $store.state.user.userInfo.fullName }}
              <feather type="chevron-down" class="d-none d-sm-inline"></feather>
            </a>
            <div class="dropdown-menu dropdown-menu-right tx-13">
              <div class="avatar avatar-lg mg-b-15">
                <img
                  :src="`${$store.state.user.userInfo.avator}`"
                  class="rounded-circle"
                  alt
                />
              </div>
              <h6 class="tx-semibold mg-b-5">
                {{ $store.state.user.userInfo.fullName }}
              </h6>
              <p
                class="mg-b-25 tx-12 tx-color-03 text-truncate"
                :title="$store.state.user.userInfo.position"
              >
                {{ $store.state.user.userInfo.position }}
              </p>
              <router-link
                v-if="
                  !$store.state.app.isMobile &&
                    !(
                      $store.state.app.activeGroup.id == 9241 ||
                      $store.state.app.activeGroup.id == 9249
                    )
                "
                :to="{ name: 'settings', params: { mode: '2' } }"
                class="dropdown-item d-flex align-items-center"
              >
                <feather
                  type="settings"
                  class="ht-20-f mg-r-5"
                ></feather
                >Тохиргоо
              </router-link>
              <router-link
                v-if="
                  !$store.state.app.isMobile &&
                    ($store.state.app.activeGroup.id == 9241 ||
                      $store.state.app.activeGroup.id == 9249)
                "
                :to="{ name: 'settings', params: { mode: '3' } }"
                class="dropdown-item d-flex align-items-center"
              >
                <feather
                  type="settings"
                  class="ht-20-f mg-r-5"
                ></feather
                >Тохиргоо
              </router-link>
              <a @click="logout" class="dropdown-item" role="button">
                <feather type="log-out" class="ht-20-f mg-r-5"></feather
                >Гарах
              </a>
            </div>
          </div>
        </div>
      </div>
      <a
        @click="changeSkin(!$store.state.app.skin.dark)"
        class="chng-skin"
        role="button"
      >
        <feather
          :type="`${$store.state.app.skin.dark ? 'sun' : 'moon'}`"
        ></feather>
      </a>
    </header>

    <header
      v-else-if="$store.state.app.mainLayoutConfig.header == 22"
      class="navbar navbar-header navbar-header-fixed"
    >
      <div class="container">
        <div
          class="navbar-brand d-none d-md-inline"
          style="padding: 0; width: auto"
        >
          <a role="button" class="d-flex">
            <div>
              <img
                class="brand-logo"
                :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                :style="`width: 100%; max-width: ${getLgMxW()}`"
              />
              <span class="tx-normal mg-l-10">{{
                $store.state.app.activeGroup.name | stripHtml
              }}</span>
            </div>
          </a>
        </div>
        <div
          :class="`navbar-right ${$store.state.app.isMobile ? 'mg-r-20' : ''} `"
          v-if="$store.state.user.userId != ''"
          style="white-space: nowrap"
        >
          <div :class="`dropdown dropdown-profile`">
            <a href class="dropdown-link" data-toggle="dropdown">
              <div class="avatar avatar-sm mg-r-10">
                <img
                  :src="`${$store.state.user.userInfo.avator}`"
                  class="rounded-circle"
                  alt
                />
              </div>
              {{ $store.state.user.userInfo.fullName }}
              <feather type="chevron-down" class="d-none d-sm-inline"></feather>
            </a>
            <div class="dropdown-menu dropdown-menu-right tx-13">
              <div class="avatar avatar-lg mg-b-15">
                <img
                  :src="`${$store.state.user.userInfo.avator}`"
                  class="rounded-circle"
                  alt
                />
              </div>
              <h6 class="tx-semibold mg-b-5">
                {{ $store.state.user.userInfo.fullName }}
              </h6>
              <p
                class="mg-b-25 tx-12 tx-color-03 text-truncate"
                :title="$store.state.user.userInfo.position"
              >
                {{ $store.state.user.userInfo.position }}
              </p>
              <router-link
                v-if="
                  !$store.state.app.isMobile &&
                    ($store.state.app.activeGroup.id == 9241 ||
                      $store.state.app.activeGroup.id == 9249)
                "
                :to="{ name: 'settings', params: { mode: '3' } }"
                class="dropdown-item d-flex align-items-center"
              >
                <feather
                  type="settings"
                  class="ht-20-f mg-r-5"
                ></feather
                >Тохиргоо
              </router-link>
              <a @click="logout" class="dropdown-item" role="button">
                <feather type="log-out" class="ht-20-f mg-r-5"></feather
                >Гарах
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <header
      v-else-if="$store.state.app.mainLayoutConfig.header == -1"
      class="navbar navbar-header navbar-header-fixed"
      :class="{'navbar-header-egazar': $store.state.app.activeGroup.id == 9379 && $route.name=='login'}"
    >
      <div
        v-if="$store.state.app.activeGroup.id == 9307"
        class="container-fluid jud-tpbar"
      >
        <div class="navbar-brand d-md-inline" style="padding: 0">
          <router-link to="/" role="button" class="d-flex align-items-center">
            <img
              class="brand-logo"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              :style="`width: 100%; max-width: ${getLgMxW()}`"
            />
            <span class="tx-normal mg-l-10 tx-white">{{
              $store.state.app.activeGroup.name | stripHtml
            }}</span>
          </router-link>
        </div>
      </div>
      <div v-else-if="$store.state.app.activeGroup.id == 9157" class="container-fluid">
        <div class="navbar-brand d-md-inline" style="padding: 0">
          <router-link to="/" role="button" class="d-flex align-items-center">
            <img
              class="brand-logo"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              :style="`width: 100%; max-width: ${getLgMxW()}`"
            />
          </router-link>
        </div>
      </div>
      <div v-else-if="$store.state.app.activeGroup.id == 9311" class="container-fluid">
        <div class="navbar-brand d-md-inline" style="padding: 0">
          <router-link to="/" role="button" class="d-flex align-items-center">
            <img
              class="brand-logo"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              :style="`width: 100%;`"
            />
          </router-link>
        </div>
      </div>
      <div v-else-if="$store.state.app.activeGroup.id==9358" class="container-fluid">
        <div class="navbar-brand d-md-inline" style="padding: 0">
          <router-link to="/" role="button" class="d-flex align-items-center text-center">
            <img
              class="brand-logo"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              :style="`width: 20px`"
            />
            <span class="mg-l-10" style="line-height: 1.1; font-weight: 600" v-html="$store.state.app.activeGroup.name"></span>
          </router-link>
        </div>
      </div>
      <div v-else-if="$store.state.app.activeGroup.id==9379" class="container">
        <div class="navbar-brand d-md-inline mg-l-15" style="padding: 0">
          <router-link to="/" role="button" class="d-flex align-items-center">
            <img
              class="brand-logo"
              :src="`${myResBaseUrl}/media/logo/gazar_logo_white.png`"
              :style="`max-height: 40px;`"
            />
          </router-link>
        </div>
      </div>
      <div v-else class="container">
      
        <a v-show="$store.state.user.userId != ''" id="mainMenuOpen" class="burger-menu" @click="mainMenuOpen()">
          <feather type="menu" class="wd-20-f ht-20-f"></feather>
        </a>
        <div class="navbar-brand d-none d-md-inline mg-l-10" style="padding: 0">
          <router-link to="/" role="button">
            <!-- <img    :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`" style="width: 100%; max-width: 40px" /> -->
            <img
              class="brand-logo"
              v-if="!$store.state.app.skin.dark"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              :style="`width: 100%; max-width: ${getLgMxW()}`"
            />
            <img
              class="brand-logo"
              v-else
              :src="
                `${myResBaseUrl}${
                  $store.state.app.activeGroup.logo.split('.')[0]
                }-white.png`
              "
              :style="`width: 100%; max-width: ${getLgMxW()}`"
            />
            <span class="tx-normal mg-l-10">{{ $store.state.app.activeGroup.name | stripHtml }}</span>
          </router-link>
        </div>
        <div id="navbarMenu" class="navbar-menu-wrapper withicon">
          <div class="navbar-menu-header">
            <router-link to="/" class="df-logo">
              Dynamic
              <span>Platform</span>
            </router-link>
            <a id="mainMenuClose" @click="backdropClick()">
              <feather type="x"></feather>
            </a>
          </div>
        </div>
      </div>
      <a
        v-if="$store.state.app.activeGroup.id != 9307"
        @click="changeSkin(!$store.state.app.skin.dark)"
        class="chng-skin"
        role="button"
      >
        <feather
          :type="`${$store.state.app.skin.dark ? 'sun' : 'moon'}`"
          class="wd-20-f ht-20-f"
        ></feather>
      </a>
    </header>
    <header
      v-else-if="$store.state.app.mainLayoutConfig.header == -2"
      class="navbar navbar-header navbar-header-fixed"
      style="width: 80px; left: 5px; top: 5px; height: 40px; z-index: 1002"
    >
      <h1>step 1</h1>
      <team-drawer></team-drawer>
    </header>
    <header
      v-else-if="$store.state.app.mainLayoutConfig.header == 201"
      class="navbar navbar-header navbar-header-fixed"
    >
      <div
        class="navbar-brand"
        style="width: auto; max-height: 60px; max-width: 76vw; padding-left: 0;"
      >
        <router-link to="/" role="button" class="d-flex">
          <img
            v-if="$store.state.app.activeGroup.id == 9235"
            src="https://ubtz.mn/images/logo/logo.png"
            class="wd-100p"
            style="max-height: 56px"
          />
          <img
            v-else-if="$store.state.app.activeGroup.id == 9362"
            src="https://vchd3.gosmart.mn/images/logo/logo.png"
            class="wd-100p"
            style="max-height: 56px"
          />
          <img
            v-else-if="$store.state.app.activeGroup.id == 9368"
            src="https://ubtz.mn/images/logo/logo.png"
            class="wd-100p"
            style="max-height: 56px"
          />
          <img
            v-else-if="$store.state.app.activeGroup.id == 9298"
            src="https://res.gosmart.mn/media/logo/stf-logo-3.png"
            class="wd-100p"
            style="max-height: 56px"
          />
          <img
            v-else-if="$store.state.app.activeGroup.id == 9300"
            src="https://elf.gov.mn/wp-content/uploads/2021/04/124.png"
            class="wd-100p"
            style="max-height: 59px"
          />
          <img
            v-else
            src="https://cdn.gosmart.mn/WT_bHWaQ7k6TqS7__VInhQ/acadmin/Image/banner(1).jpg"
            class="wd-100p"
            style="max-height: 59px"
          />
        </router-link>
      </div>

      <div class="navbar-right" style="width: auto !important">
        <div :class="`dropdown dropdown-profile`">
          <a href class="dropdown-link" data-toggle="dropdown">
            <div class="avatar avatar-sm mg-r-10">
              <img
                :src="`${$store.state.user.userInfo.avator}`"
                class="rounded-circle"
                alt
              />
            </div>
            {{ $store.state.user.userInfo.fullName }}
            <feather type="chevron-down" class="d-none d-sm-inline"></feather>
          </a>
          <div class="dropdown-menu dropdown-menu-right tx-13">
            <div class="avatar avatar-lg mg-b-15">
              <img
                :src="`${$store.state.user.userInfo.avator}`"
                class="rounded-circle"
                alt
              />
            </div>
            <h6 class="tx-semibold mg-b-5">
              {{ $store.state.user.userInfo.fullName }}
            </h6>
            <p
              class="mg-b-25 tx-12 tx-color-03 text-truncate"
              :title="$store.state.user.userInfo.position"
            >
              {{ $store.state.user.userInfo.position }}
            </p>
            <router-link
              v-if="
                !$store.state.app.isMobile &&
                  !(
                    $store.state.app.activeGroup.id == 9241 ||
                    $store.state.app.activeGroup.id == 9249
                  )
              "
              :to="{ name: 'settings', params: { mode: '2' } }"
              class="dropdown-item d-flex align-items-center"
            >
              <feather type="settings" class="ht-20-f mg-r-5"></feather
              >Тохиргоо
            </router-link>
            <router-link
              v-if="
                !$store.state.app.isMobile &&
                  ($store.state.app.activeGroup.id == 9241 ||
                    $store.state.app.activeGroup.id == 9249)
              "
              :to="{ name: 'settings', params: { mode: '3' } }"
              class="dropdown-item d-flex align-items-center"
            >
              <feather type="settings" class="ht-20-f mg-r-5"></feather
              >Тохиргоо
            </router-link>
            <a @click="logout" class="dropdown-item" role="button">
              <feather type="log-out" class="ht-20-f mg-r-5"></feather>Гарах
            </a>
          </div>
        </div>
      </div>
    </header>
    <header
      v-else-if="$store.state.app.mainLayoutConfig.header == 202"
      class="navbar navbar-light bg-light"
    >
      <router-link
        :to="{ name: 'homeyouth' }"
        class="btn btn-sm pd-x-15 btn-white btn-uppercase"
        ><feather type="arrow-left"></feather> Буцах</router-link
      >
    </header>

    <keep-alive :include="cacheList">
      <router-view>
        <slot name="content-header"></slot>
      </router-view>
    </keep-alive>
    <footer class="footer" v-if="$store.state.app.mainLayoutConfig.footer">
      <div>
        <span>
          <a href="https://support.gosmart.mn/page/6052281/6138061" target="_blank"
            >&copy; 2025 Динамик платформ v4.{{ buildVersion }}</a
          >
        </span>

        <!-- <span>Developed by <a href="http://gosmart.mn" target="_blank">All Ink</a></span> -->
      </div>
      <div>
        <nav v-if="$store.state.app.activeGroup.id == 9132" class="nav">
          <a href="https://mnuac.edu.mn" target="_blank" class="nav-link"
            >mnuac.edu.mn</a
          >
          <a href="https://support.gosmart.mn/page/6052281/6138061" target="_blank" class="nav-link"
            >Шинэчлэл</a
          >
          <a
            :href="$store.state.app.activeGroup.helpPageUrl"
            target="_blank"
            class="nav-link"
            >Гарын авлага</a
          >
          <a href="https://www.gosmart.mn" target="_blank" class="nav-link">
            <img
              :src="`${myResBaseUrl}/media/favicon/fav.png`"
              style="height: 14px"
            />
            Хөгжүүлсэн Гөүсмарт ТМ ХХК</a
          >
        </nav>
        <nav v-else class="nav">
          <!-- || $store.state.app.activeGroup.id == 9365 -->
          <a v-if="$store.state.app.activeGroup.id == 9298
          || $store.state.app.activeGroup.id == 9379
          || $store.state.app.activeGroup.id == 9254
          " @click="showAdminLogin()" role="button" class="nav-link">Админ</a>
          <a v-if="$store.state.app.activeGroup.id == 9254 " href="/academy/#/certificate" class="nav-link">Сертификат шалгах</a>
          <a v-else href="/#/certificate" class="nav-link">Сертификат шалгах</a>
          <a href="https://www.gosmart.mn" target="_blank" class="nav-link"
            >Үйлчилгээний нөхцөл</a
          >
          <a href="https://support.gosmart.mn/page/6052281/6138061" target="_blank" class="nav-link"
            >Шинэчлэл</a
          >
          <a
            :href="$store.state.app.activeGroup.helpPageUrl"
            target="_blank"
            class="nav-link"
            >Гарын авлага</a
          >
          <a href="https://www.gosmart.mn" target="_blank" class="nav-link">
            <img
              :src="`${myResBaseUrl}/media/favicon/fav.png`"
              style="height: 14px"
            />
            Хөгжүүлсэн Гөүсмарт ТМ ХХК</a
          >
        </nav>
      </div>
    </footer>
    <b-overlay
      :show="$store.state.app.loading"
      no-wrap
      fixed
      :z-index="99999"
    />
    <!-- <div class="aside-backdrop"></div> -->
    <div
      @click="backdropClick()"
      v-if="
        $store.state.app.responsiveLayout.backdrop.show == true &&
          $store.state.app.responsiveLayout.backdrop.class == 'backdrop'
      "
      class="backdrop"
    ></div>
    <div></div>
    <div class="locker-loader">
      <div class="locker-main" style="min-width: 140px">Түр хүлээнэ үү...</div>
    </div>

    <user-info :isShow.sync="showNameCard" @on-hide="hideNameCard()" />
    <template v-if="$store.state.signalr.osrCon != ''">
      <messenger-area
        :isShow.sync="showMessenger"
        @on-hide="hideMessenger()"
        class="dnmc-msngr"
      />
    </template>
    <compose-local-mail @on-hide="hideLocalMailCompose()" />
    <template v-if="showMainReportDialog">
      <report-dialog
        v-if="reportDialog.id > 0"
        :id.sync="reportDialog.id"
        :obj.sync="reportDialog.obj"
        @on-report-close="reportClosed()"
      ></report-dialog>
    </template>

    <b-modal v-model="alertObj.modal" hide-footer size="lg" title="Мэдээлэл">
      <div>
        <h5 v-html="alertObj.task.task"></h5>
        <div
          v-html="alertObj.task.taskDesc"
          class="dtlArea"
          style="width: 100%; overflow: hidden"
        ></div>
      </div>
    </b-modal>

    <b-modal v-model="goToExam.modal" hide-footer title="Шалгалтын мэдээлэл">
      <div class="d-flex bd-b pd-b-10">
        <a href="javascript: void(0)" class="avatar">
          <img
            :src="$store.state.user.userInfo.avator"
            class="rounded-circle"
            alt
          />
        </a>
        <div class="pd-l-10">
          <h6 class="tx-semibold mg-b-0">
            Нэр: {{ $store.state.user.userInfo.fullName }}
          </h6>
          <p class="tx-color-03 tx-12 mg-b-0">
            Регистр: {{ $store.state.user.userInfo.register }}
          </p>
          <p class="tx-color-03 tx-12 mg-b-0">
            Нэвтрэх нэр: {{ $store.state.user.userInfo.user_name }}
          </p>
        </div>
      </div>
      <div class="">
        <div class="row">
          <div class="col-6">
            <label
              class=" tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10"
              >Сургалт</label
            >
            <p class="mg-b-0">{{ goToExam.obj.courseName }}</p>
          </div>
          <div class="col-6">
            <label
              class=" tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10"
              >Шалгалт</label
            >
            <p class="mg-b-0">{{ goToExam.obj.formName }}</p>
          </div>
          <div class="col-6">
            <label
              class=" tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10"
              >Шалгалтын үргэлжлэх хугацаа</label
            >
            <div>
              <p class="mg-b-0 pd-l-8">
                Эхлэх: {{ goToExam.obj.startDate | moment("YYYY.MM.DD HH:mm") }}
              </p>
              <p class="mg-b-0">
                Дуусах: {{ goToExam.obj.endDate | moment("YYYY.MM.DD HH:mm") }}
              </p>
              <!-- <p class="mg-b-0 mg-l-20" v-html="goToExam.obj.duration"></p> -->
            </div>
          </div>
          <div class="col-6">
            <label
              class=" tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10"
              >Асуултын тоо</label
            >
            <p class="mg-b-0">{{ goToExam.obj.questionCount }}</p>
          </div>
        </div>
      </div>
      <div class="bd-t pd-t-10">
        <!-- <button @click="goToExam.modal= false" class="btn btn-sm btn-primary"><feather type="home" class="mg-r-5" ></feather>Эхлэл</button> -->
        <div class="mg-b-10">
          <div role="alert" class="alert alert-info fade show">
            <strong
              >Та дээрх мэдээллийг нягтлаад үргэлжлүүлэх дарснаар шалгалтад
              оролцох боломжтой болно.</strong
            >
          </div>
        </div>
        <button @click="joinExam()" class="btn btn-sm btn-success wd-100p">
          <feather type="check-square" class="mg-r-5"></feather>Үргэлжлүүлэх
        </button>

        <div class="mg-t-10">
          <div
            role="alert"
            class="alert alert-warning alert-dismissible fade show"
          >
            <strong
              >Хэрэв дундын ашигладаг компьютерээс хандаж буй бол хэрэглэгчийн
              мэдээллээ нягтлаад зөрүүтэй бол системээс гарах дарж өөрийн эрхээр
              нэвтэрнэ үү.</strong
            >
          </div>
          <div class="d-flex">
            <button @click="logout" class="btn btn-sm btn-danger mg-l-auto">
              <feather type="log-out" class="mg-r-5"></feather>Системээс гарах
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="examV5Modal" hide-footer title="Шалгалтын мэдээлэл">
      
      <div class="bd-t pd-t-10">
        <!-- <button @click="goToExam.modal= false" class="btn btn-sm btn-primary"><feather type="home" class="mg-r-5" ></feather>Эхлэл</button> -->
        <div class="mg-b-10">
          <div role="alert" class="alert alert-info fade show">
            <strong
              >Танд оролцох боломжтой шалгалтын мэдээлэл байна. Доорхи товчийг дарснаар шалгалтын системдрүү шилжих болно !</strong
            >
          </div>
        </div>

        <div class="mg-t-10">
          <div class="d-flex">
            <button @click="goToExamV5()" class="btn btn-sm btn-warning mg-l-auto">
              <feather type="log-out" class="mg-r-5"></feather>Шалгалтын системд нэвтрэх
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="modalTmxExam"
      hide-footer
      title="Татварын бүртгэл улсын олимпиадын бүртгэл"
    >
      <div class="form-group mg-b-10">
        <label class="mg-b-0-f">Одоогийн төлөв сонгоно уу</label>
        <div class="d-flex">
          <Select
            @change="locTypeId4Changed"
            v-model="modalTmxExamObj.locTypeId4"
            class="wd-100p"
            placeholder="-- Сонгоно уу --"
            clearable
          >
            <Option label="Оюутан" :value="81185"></Option>
            <Option label="Нягтлан бодогч" :value="81190"></Option>
          </Select>
        </div>
      </div>
      <template v-if="!modalTmxExamHide">
        <div class="form-group mg-b-10">
          <label class="mg-b-0-f">Хүйс</label>
          <loc-type-cascader
            :id="modalTmxExamObj.locTypeId1"
            v-model="modalTmxExamObj.locTypeId1"
            locTypekey="sysGlobalRefGender"
            class="wd-100p"
            disableAdd
          />
        </div>
        <div class="form-group mg-b-10">
          <label class="mg-b-0-f">{{
            modalTmxExamObj.locTypeId4 == 81190
              ? "Одоо ажиллаж буй аймаг/дүүрэг, сум"
              : "Үндсэн захиргаа /төрсөн аймаг, дүүрэг, сум"
          }}</label>
          <loc-type-cascader
            :id="modalTmxExamObj.locTypeId3"
            v-model="modalTmxExamObj.locTypeId3"
            locTypekey="sysRefProvince"
            class="wd-100p"
            disableAdd
          />
        </div>
        <template v-if="modalTmxExamObj.locTypeId4 == 81190">
          <div class="form-group mg-b-10">
            <label class="mg-b-0-f">Одоо ажиллаж буй ажлын газрын нэр</label>
            <input
              v-model="modalTmxExamObj.position"
              type="text"
              class="form-control"
              placeholder="Одоо ажиллаж буй ажлын газрын нэр"
            />
          </div>
          <div class="form-group mg-b-10">
            <label class="mg-b-0-f"
              >Нягтлан бодогчоор төсөвт байгууллагад ажилласан жил</label
            >
            <input
              v-model="modalTmxExamObj.i6"
              type="number"
              class="form-control"
              placeholder="Нягтлан бодогчоор төсөвт байгууллагад ажилласан жил"
            />
          </div>
        </template>

        <div class="form-group mg-b-10">
          <label class="mg-b-0-f">{{
            modalTmxExamObj.locTypeId4 == 81190
              ? "Нягтлан бодогч мэргэжлээр төгссөн сургуулийн нэр"
              : "Их, дээд сургуулийн нэр"
          }}</label>
          <input
            v-model="modalTmxExamObj.s15"
            type="text"
            class="form-control"
            :placeholder="
              modalTmxExamObj.locTypeId4 == 81190
                ? 'Нягтлан бодогч мэргэжлээр төгссөн сургуулийн нэр'
                : 'Их, дээд сургуулийн нэр'
            "
          />
        </div>
        <div class="form-group mg-b-10">
          <label class="mg-b-0-f">{{
            modalTmxExamObj.locTypeId4 == 81190
              ? "Нягтлан бодогч мэргэжлээр төгссөн он"
              : "Их, дээд сургуульд элссэн он"
          }}</label>
          <input
            v-model="modalTmxExamObj.i7"
            type="number"
            class="form-control"
            :placeholder="
              modalTmxExamObj.locTypeId4 == 81190
                ? 'Нягтлан бодогч мэргэжлээр төгссөн он'
                : 'Их, дээд сургуульд элссэн он'
            "
          />
        </div>
        <button
          @click="modalTmxExamObjSave()"
          class="btn btn-brand-02 btn-block"
        >
          Хадгалах
        </button>
      </template>
    </b-modal>

    <!-- <button
      @click="showHelpButton"

      v-if="$store.state.app.activeGroup.id == 9265 && $route.name!='login'"
      :class="`
        pos-fixed
        b-${$route.name=='login'?'50':'20'}
        l-20
        text-uppercase
        btn btn-xs btn-warning btn-icon
        rounded-pill
      `"
    >
      <feather type="help-circle" class="ht-20-f wd-20-f"></feather>
    </button> -->
    <help-notif></help-notif>
    
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";
import { localRead, getToken } from "@/libs/util";

import CryptoJS from "crypto-js";

import { mapActions } from "vuex";
//import { hasOneOf } from "@/libs/tools";
//import { request } from "@/api/all";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import config from "@/config";

const { mobAppActiveGroup, lmsPages, stfPages, elfPages } = config;

import "element-ui/lib/theme-chalk/index.css";
import { Autocomplete, Select, Option, Notification } from "element-ui";

const moment = require("moment");

export default {
  name: "Main",
  components: {
    Autocomplete,
    //Notification,
    Select,
    Option,
    vueCustomScrollbar,
    // skinGolomt: () => ({
    //   component: import("@/views/skins/golomt"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    mainMenu: () => ({
      component: import("@/views/main/menu.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    userInfo: () => ({
      component: import("@/components/main/userInfo.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    messengerArea: () => ({
      component: import("@/components/main/messenger.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    headerBarNotification: () => ({
      component: import("@/components/modules/team/headerBarNotification"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    headerBarLocalmail: () => ({
      component: import("@/views/modules/localmail/headerBarMailNotification"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    composeLocalMail: () => ({
      component: import("@/views/modules/localmail/compose"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 20000,
    }),
    teamDrawer: () => ({
      component: import("@/components/modules/team/drawer.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 20000,
    }),
    reportDialog: () => ({
      component: import("@/views/modules/report/dialog"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    helpNotif: () => ({
      component: import("@/views/main/helpNotif.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data: () => ({
    buildVersion: config.buildVersion,
    examV5FormId: null,
    examV5Modal: false,

    modalTmxExam: false,
    modalTmxExamHide: true,
    modalTmxExamObj: {},
    showHomePage: false,
    showLocalCompose: false,
    timer: "",

    myResBaseUrl: "https://res.gosmart.mn/",
    activeGroup: {
      id: 0,
      name: "",
      log: "",
    },
    courseState: "",
    courseArr: [],
    showNameCard: false,
    showMessenger: false,
    menu: {
      vet: {
        admin: false,
        client: false,
        meesbul: false,
        pharma: false,
        zuvlul: false,
      },
    },
    tasksCount: 0,
    tasksCountUnseen: 0,
    isVet: false,
    isVetKey: 0,
    myMobAppActiveGroup: null,
    skinClass: "",
    localMailModal: true,
    deferredPrompt: null,
    onlyIphone: false,
    ioszaawar: false,
    installPWA: false,
    showMainReportDialog: false,
    reportDialog: {
      id: 0,
      obj: {},
      propObj: {},
    },

    alertObj: {
      task: {},
      modal: false,
    },

    goToExam: {
      obj: {
        courseId: null,
        courseName: "",
        formId: null,
        formName: "",
        startDate: null,
        endDate: null,
        duration: null,
        questionCount: null,
      },
      formId: null,
      modal: false,
    },
  }),
  created() {
    this.fetchResBase();
    // alert('1');
    this.modalNotification(1);

    if (this.$route.name != "examOnline") {
      this.timer = setInterval(this.modalNotification(0), 300000);
      //this.timer = setInterval(this.modalNotification, 3000);

      if (this.$store.state.user.userId != "") {
        this.modalAlert();
      }
    }

    if (this.installPWA) {
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });
      window.addEventListener("appinstalled", () => {
        this.deferredPrompt = null;
      });
      this.IOS();
    }
    //console.log('master page fired', this.$route.name);

    this.manageTailwind();

    if (hasOneOf(lmsPages, [this.$route.name])) {
      //console.log('stpr 1');
      if (hasOneOf(['lmsParticipant', 'buddyParticipant', 'buddyWorker', 'buddyChief', 'buddyDepartDashboard', 'buddyAdminDashboard',
      ], [this.$route.name])) {
        //console.log('stpr 2');
        this.toggleBodyClass("addClass", "show-sidebar-right");
      }
      require("@/assets/scss/pages/learning.scss");

      this.toggleBodyClass("addClass", "app-lms");

      let _obj = this.$store.state.app.mainLayoutConfig;
      _obj.header = null;
      _obj.expanded = true;

      if (this.$route.name == "userProfile") {
        if (
          this.hasPermission([
            "stf_proj_sudlaach",
            "stf_proj_shinjeech",
            "elf_student",
          ])
        ) {
          _obj.header = 201;
        } else if (this.$store.state.app.activeGroup.id == 9272) {
          _obj.header = 202;
        }
        //console.log('stpr 2')
      }
// console.log(this.$route.name)
      if (this.$route.name == "settings" && this.$store.state.app.activeGroup.id == 9272) {
        _obj.header = 202;
      }

      this.handleMainLayoutConfig(_obj);
    } else if (
      hasOneOf(stfPages, [this.$route.name]) ||
      hasOneOf(elfPages, [this.$route.name])
    ) {
      //console.log('stpr 2');
      require("@/assets/scss/pages/learning.scss");
      let _obj = this.$store.state.app.mainLayoutConfig;
      _obj.aside = false;
      _obj.header = null;
      _obj.expanded = true;
      this.handleMainLayoutConfig(_obj);
      this.toggleBodyClass("addClass", "app-lms");
    }
    // else if(this.$store.state.app.activeGroup.id==9272){
    //   let _obj = this.$store.state.app.mainLayoutConfig;
    //   _obj.header = 201;
    //   this.handleMainLayoutConfig(_obj);
    // }

    // else if(hasOneOf(elfPages, [this.$route.name])){
    //   require('@/assets/scss/pages/learning.scss');
    //   let _obj = this.$store.state.app.mainLayoutConfig;
    //   _obj.aside = false;
    //   _obj.header = null;
    //   _obj.expanded = true;
    //   this.handleMainLayoutConfig(_obj);
    //   this.toggleBodyClass("addClass", "app-lms");
    // }
    else {
      //console.log(this.$route);
    }
  },
  mounted() {
    // this.fetchResBase();
    //console.log('master page fired', document.location.hostname);
    if (
      document.location.hostname == "vetdrug.mn" ||
      document.location.hostname == "www.vetdrug.mn" ||
      document.location.hostname == "192.168.0.105"
    ) {
      this.$nextTick(function() {
        this.isVet = true;
        this.isVetKey++;
      });
    }
    // else if ( !this.$store.state.app.isMobile
    //   && (document.location.hostname == "academy.golomtbank.com"
    //   || document.location.hostname == "www.academy.golomtbank.com"
    //   || document.location.hostname == "192.168.0.105"
    //   )
    // ) {
    //   //console.log('academy.golomtbank.com');
    //   this.$router.push({ name: 'notfound' })
    // }

    //this.checkMobile();

    this.buildMenu();
    this.initCounts();
    this.skinOverride();

    this.checkTmxExam();
  },
  computed: {
    cacheList() {
      return ["ParentView", ...[]];
    },
    userId() {
      return this.$store.state.user.userId;
    },
    _osrCon() {
      //console.log("end yu bdiin", this.$store.state.signalr.osrCon);
      return this.$store.state.signalr.osrCon;
    },
    userInfoModalComp() {
      return this.$store.state.app.userInfoId;
    },
    asideMinimize() {
      return this.$store.state.app.aside.minimize;
    },
    asideMaximize() {
      return this.$store.state.app.aside.maximize;
    },
    mainReportDialogComp() {
      return this.$store.state.app.mainReportData.show;
    },
    messengerComp() {
      //console.log(this.$store.state.app.messenger.open);
      return this.$store.state.app.messenger.open;
    },
  },
  watch: {
    _osrCon: {
handler(newValue, oldValue) {
  //console.log(newValue, oldValue);
      if (newValue != "") {
        this.signalrAfter();
      }
}, 
immediate: true,
      
    },
    messengerComp(newValue) {
      //console.log('step 2');
      if (newValue != 0) {
        this.showMessenger = true;
      } else {
        this.showMessenger = false;
      }
    },
    userInfoModalComp(newValue) {
      //console.log('stp3');
      if (newValue != 0) {
        this.showNameCard = true;
      } else {
        this.showNameCard = false;
      }
    },
    mainReportDialogComp(newValue) {
      if (newValue != 0) {
        this.initReportDialog();
      } else {
        this.showMainReportDialog = false;
      }
    },
    asideMinimize: function(newVal, oldVal) {
      //console.log("aside minimized");
      if (oldVal != newVal) this.configAside();
    },
    asideMaximize: function(newVal, oldVal) {
      //console.log("aside maximized");
      if (oldVal != newVal) this.configAside();
    },
    userId: {
      handler(newVal, oldVal) {
        //console.log("user uid watched");
        if (oldVal != newVal) {
          Object.assign(this.$data, this.$options.data());
          this.fetchResBase();
          this.initCounts();
          this.buildMenu();
          this.skinOverride();
          //console.log(newVal);
          if (newVal != "") {
            this.modalNotification(1);
            this.modalAlert();
          }
        }
      },
      immediate: true, // This ensures the watcher is fired on component creation
    },
    // userId: function(newVal, oldVal) {
    //console.log('userId watched')

    // },
    "$root.$route"(newRoute, oldRoute) {
      //console.error('newRoute.name=> ', newRoute.name, oldRoute.name);
      // if(hasOneOf(lmsPages, [newRoute.name])){
      //   require('@/assets/scss/pages/learning.scss');
      //console.error(' za endl ');
      // }
      //console.log('watcher stpr 1 this.hasLmsPages()', this.$route.name);
      this.manageTailwind();

      if (this.hasLmsPages()) {
        require("@/assets/scss/pages/learning.scss");

        //console.log('watcher stpr 1 this.hasLmsPages()', this.$route.name);
        let _obj = this.$store.state.app.mainLayoutConfig;
        _obj.header = null;
        _obj.expanded = true;

        if (this.$route.name == "userProfile") {
          if (
            this.hasPermission([
              "stf_proj_sudlaach",
              "stf_proj_shinjeech",
              "elf_student",
            ])
          ) {
            _obj.header = 201;
          } else if (this.$store.state.app.activeGroup.id == 9272) {
            _obj.header = 202;
          }
        }

        this.handleMainLayoutConfig(_obj);
        this.toggleBodyClass("addClass", "app-lms");

        
        //if (newRoute.name == "lmsParticipant") 
        if (hasOneOf(['lmsParticipant', 'buddyParticipant', 'buddyWorker', 'buddyChief', 'buddyDepartDashboard', 'buddyAdminDashboard'], [newRoute.name])) {
          //console.log('watcher stpr 1 => newRoute.name == "lmsParticipant"');
          //console.error('newRoute.name=> stp 3', newRoute.name);
          this.toggleBodyClass("addClass", "show-sidebar-right");
          this.checkTmxExam();
        } else {
          this.toggleBodyClass("removeClass", "show-sidebar-right");
        }
      } else if (this.hasStfPages() || this.hasElfPages()) {
        require("@/assets/scss/pages/learning.scss");
        let _obj = this.$store.state.app.mainLayoutConfig;
        _obj.aside = false;
        _obj.header = null;
        _obj.expanded = true;
        this.handleMainLayoutConfig(_obj);
        this.toggleBodyClass("addClass", "app-lms");
      }
      // else if(this.hasElfPages()){
      //   require('@/assets/scss/pages/learning.scss');
      //   let _obj = this.$store.state.app.mainLayoutConfig;
      //   _obj.aside = false;
      //   _obj.header = null;
      //   _obj.expanded = true;
      //   this.handleMainLayoutConfig(_obj);
      //   this.toggleBodyClass("addClass", "app-lms");
      // }
    },
  },
  methods: {
    manageTailwind() {
        // console.log('manageTadfilwind fired');
        if (hasOneOf(lmsPages, [this.$route.name])) {
            // console.log('tw 1: Adding Tailwind CSS');

            // Check if Tailwind CSS is already loaded
            if (!document.querySelector('link[href*="tailwind.min.css"]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = `${this.myResBaseUrl}css/tailwind.min.css`;
                // link.href = `https://cdn.jsdelivr.net/npm/tailwindcss@latest/dist/tailwind.min.css`;
                document.head.appendChild(link);
                // console.log('Tailwind CSS added');
            } else {
                // console.log('Tailwind CSS already loaded');
            }
        } else {
            // console.log('tw 2: Removing Tailwind CSS');
            const styleElement = document.querySelector('link[href*="tailwind.min.css"]');
            if (styleElement) {
                // console.log('tw 3: Tailwind CSS found, removing...');
                styleElement.parentNode.removeChild(styleElement);
            } else {
                // console.log('tw 3: Tailwind CSS not found.');
            }
        }
    },
    showAdminLogin(){
      let _obj=this.$store.state.app.adminLogin;
      _obj.modal= true;
      this.handleAdminLogin(_obj);
    },
    ...mapActions([
      "handleAdminLogin",
      "handleLoading",
      "handleAside",
      "handleLogOut",
      "handleDynamicMenuLoaded",
      "handleDarkSkin",
      "handleUserInfoModal",
      "handleResponsiveLayoutConfig",
      "resetResponsiveLayoutConfig",
      "handleIsMobile",
      "handleLocalMailCompose",
      "handleMainReportDialog",
      "handleActiveForm",
      "handleMessenger",
      "handleMainLayoutConfig",

      "handleBoxSummary",
    ]),
    playSound() {
      var audio = new Audio("https://res.gosmart.mn/media/sound/notif.mp3");
      audio.play();
    },
    notifyMe() {
      if (!("Notification" in window)) {
        //console.log("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        var notification = new Notification("Динамик платформ", {
          icon: "https://res.gosmart.mn/media/icon.png",
          body: "Танд шинэ идэвхтэй ажилбар ирлээ!",
        });
        notification.onclick = function() {
          let url = window.location.protocol + "//" + window.location.host;
          window.open(url);
        };
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function(permission) {
          if (permission === "granted") {
            var notification = new Notification("Динамик платформ", {
              icon: "https://res.gosmart.mn/media/icon.png",
              body: "Танд шинэ идэвхтэй ажилбар ирлээ!",
            });
            notification.onclick = function() {
              let url = window.location.protocol + "//" + window.location.host;
              window.open(url);
            };
          }
        });
      } else {
        //console.log("notifperm", Notification.permission);
      }
    },

    // showHelpButton() {
    //   Notification.warning({
    //     message:
    //       "Тусламж хэрэгтэй бол online@bfa.mn мэйл хаягаар хүсэлтээ илгээнэ үү.",
    //     title: "Тусламж",
    //     duration: 30000,
    //     type: "info",
    //     position: "bottom-left",
    //     offset: 50,
    //   });
    // },
    signalrAfter() {
      //console.log("signalR after");
      this.$store.state.signalr.osrCon.on("onPinnedTaskUpdated", (id) => {
        this.tasksCountUnseen++;
        this.playSound();
        //if(!this.$store.state.app.windowState){
        // this.notifyMe();
        //}
      });
      this.$store.state.signalr.osrCon.on("onPinnedTaskRemoved", (id) => {
        if (this.tasksCountUnseen > 0) this.tasksCountUnseen--;
      });
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    getLgMxW() {
      let rv = "40px";
      if (this.$store.state.app.activeGroup.id == 9281) {
        rv = "160px";
      } else if (this.$store.state.app.activeGroup.id == 9283) {
        rv = "240px";
      } else if (this.$store.state.app.activeGroup.id == 9157) {
        rv = "240px";
      } else if (this.$store.state.app.activeGroup.id == 9358) {
        rv = "20px";
      }
      return rv;
    },
    IOS() {
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
      };
      // Detects if device is in standalone mode
      const isInStandaloneMode = () =>
        "standalone" in window.navigator && window.navigator.standalone;

      // Checks if should display install popup notification:
      if (isIos() && !isInStandaloneMode()) {
        this.onlyIphone = true;
      }
    },
    hideIOS() {
      this.onlyIphone = false;
    },
    showIOS() {
      this.ioszaawar = true;
      this.onlyIphone = false;
    },
    closeTutorial() {
      this.ioszaawar = false;
      this.onlyIphone = false;
    },
    async dismiss() {
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    mainMenuOpen() {
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
      });
    },
    hideLocalMailCompose() {
      let obj = this.$store.state.app.localCompose;
      obj.isShow = false;
      obj.taskIds = [];
      obj.attachIds = [];
      obj.userIds = [];
      this.handleLocalMailCompose(obj);
    },
    skinOverride() {
      // let currentApp=config.mobApps.filter(x=>x.id == mobAppActiveGroup);
      // if(currentApp.length>0){
      //   this.skinClass=currentApp[0].skin;
      // }
      //console.log('this.$store.state.app.activeGroup', this.$store.state.app.activeGroup);
      this.skinClass = this.$store.state.app.activeGroup.skin;
      if (this.$store.state.app.skin.dark) {
        this.toggleBodyClass("addClass", "is-dark");
      }

      this.myMobAppActiveGroup = mobAppActiveGroup;
      // if(this.$route.name=='lmsParticipant'){
      //   require('@/assets/css/dashforge.profile.css');
      // }

      // if (mobAppActiveGroup == 9241) {
      // //require('@/assets/css/custom/golomt.less');
      // require("@/assets/scss/overrides/_golomt.scss");
      // }

      // if (this.$store.state.app.skin.dark) {
      //   //require("@/assets/css/skin.dark.css");
      //   require("@/assets/scss/skins/dark.scss");
      // }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    initCounts() {
      if (this.$store.state.user.userId != "") {
        request({
          api: { method: "get", url: "task/GetPinnedTaskCount" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.tasksCount = res.data.count;
            this.tasksCountUnseen = res.data.unseenCount;
          }
        });

        // let _attaches= window.localStorage.getItem('off_files')
        // if(_attaches) {
        //   this.offlineCounts= JSON.parse(_attaches).length;
        // }
      }
    },
    backdropClick() {
      if (
        !this.$store.state.app.aside.minimize &&
        !this.$store.state.app.aside.maximize
      ) {
        if (screen.width <= 1024) {
          window.$("body").removeClass("show-aside");
        }
      }

      this.resetResponsiveLayoutConfig(document);
    },
    configAside() {
      if (
        this.$store.state.app.aside.minimize &&
        !this.$store.state.app.aside.maximize
      ) {
        if (screen.width <= 1024) {
          this.handleAside({ minimize: false, maximize: true });
          window.$("body").addClass("show-aside");
        }
      }
      // if (
      //   !this.$store.state.app.aside.minimize &&
      //   !this.$store.state.app.aside.maximize
      // ) {
      //   if (screen.width <= 1024) {
      //     window.$("body").removeClass("show-aside");
      //   }
      // }
    },
    hasLmsPages() {
      //console.log('lmsPages', lmsPages);
      return hasOneOf(lmsPages, [this.$route.name]);
    },
    hasStfPages() {
      //console.log('stfPages', stfPages);
      //console.log('stfPages', stfPages, this.$route.name);
      return hasOneOf(stfPages, [this.$route.name]);
    },
    hasElfPages() {
      //console.log('elfPages', elfPages);
      //console.log('stfPages', stfPages, this.$route.name);
      return hasOneOf(elfPages, [this.$route.name]);
    },
    buildMenu() {
      if (hasOneOf(["vetmedadmin"], this.$store.state.user.access)) {
        this.menu.vet.admin = true;
      }
      if (hasOneOf(["vetmedmeesbul"], this.$store.state.user.access)) {
        this.menu.vet.meesbul = true;
      }
      if (hasOneOf(["vetmedpharma"], this.$store.state.user.access)) {
        this.menu.vet.pharma = true;
      }
      if (hasOneOf(["vetmedzuvlul"], this.$store.state.user.access)) {
        this.menu.vet.zuvlul = true;
      }
    },
    logout() {
      this.handleLoading({ isLoading: true });
      this.handleLogOut({ store: this.$store }).then((res) => {
        if (res != false) {
          this.handleDynamicMenuLoaded(false);
          this.handleLoading({ isLoading: false });
          this.$router.push({ name: "login" });
        }
      });
    },
    changeAside(mi, ma) {
      this.handleAside({ minimize: mi, maximize: ma });
    },
    asideEnter() {
      // if(this.$store.state.app.aside.minimize){
      //   window.$('.aside').parent().addClass('maximize');
      // }
    },
    turnToPage(route) {
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }

      if (this.$route.name != route.name)
        this.$router.push({ name, params, query });
    },
    changeSkin(v) {
      this.handleLoading({ isLoading: true });
      this.handleDarkSkin(v).then(() => {
        this.handleLoading({ isLoading: false });
        this.$router.go();
      });
    },
    hideMessenger() {
      let obj = this.$store.state.app.messenger;
      obj.open = false;
      this.handleMessenger(obj).then(() => {
        this.showMessenger = false;
      });
    },
    hideNameCard() {
      this.handleUserInfoModal(0).then((res) => {
        if (res != undefined && res == 0) {
          this.showNameCard = false;
        }
      });
    },
    querySearch(queryString, cb) {
      if (queryString.length >= 1) {
        request({
          api: { method: "POST", url: "v2/Learn/GetCourses" },
          data: {
            skip: 0,
            size: 10,
            name: queryString,
            startDate: null,
            endDate: null,
            locTypeId: null,
            locTypeId1: null,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.courses = res.data.courses;

            this.courseArr = res.data.courses.map((e) => {
              return {
                id: e.id,
                value: e.name,
                percent: e.myShare != null ? e.myShare.percent : 0,
                isJoined: e.myShare != null,
              };
            });
            cb(this.courseArr);
          }
        });
      }
    },
    handleSelect(item) {
      this.courseState = "";
      if (item.isJoined) {
        this.$router.push({
          name: "lmsCourseView",
          params: {
            id: item.id,
            bid: 0,
            iid: 0,
            bot: 0,
          },
        });
      } else {
        this.$router.push({
          name: "lmsAttend",
          params: {
            id: item.id,
            s1: 0,
            s2: 0,
          },
        });
      }
    },
    checkMobile() {
      //console.log('checkMobile fired');
      if (screen.width <= 1024) {
        //console.log('screen.width <= 1024', screen.width <= 1024);
        this.handleIsMobile(true);
      }
    },
    initReportDialog() {
      //this.$store.state.app.mainReportData.key
      //1 get loadedReports
      this.$nextTick(() => {
        request({
          api: { url: "Report/DownloadedReports", method: "GET" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            //this.downloadedReports= ;
            //this.downloadedRdy= true;
            let rpt = res.data.list.filter(
              (x) => x.key == this.$store.state.app.mainReportData.key
            );
            if (rpt.length > 0) {
              //console.log(rpt[0])
              this.reportDialog.obj = {
                id: rpt[0].id,
                task: rpt[0].task,
                langCode: rpt[0].langCode,
                phone: rpt[0].phone,
                courseId: rpt[0].courseId,
              };
              this.reportDialog.id = rpt[0].id;
              this.$nextTick(() => {
                this.showMainReportDialog = true;
              });
            } else {
              this.$bvToast.toast(
                "Тайлан татагдаагүй байна. Байгууллага хариуцсан админд хандана уу",
                {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "info",
                  toaster: "b-toaster-top-center",
                }
              );
              this.handleMainReportDialog({
                key: "",
                show: false,
                propObj: {},
              });
            }
            //console.log(res);
          }
        });
      });
    },
    reportClosed() {
      this.handleMainReportDialog({ key: "", show: false, propObj: {} });
      this.reportDialog.id = 0;
      this.showMainReportDialog = false;
      //console.log("report closed")
    },
    joinExam() {
      this.$router.push({
        name: "examOnline",
        params: {
          courseId: this.goToExam.obj.courseId,
          formId: this.goToExam.obj.formId,
          lessonId: 0,
          boxId: 0,
          boxOt: 0,
        },
      });
    },
    goToExamV5(){
      let _url= "";
      if(this.$store.state.app.activeGroup.v5ExamBaseUrl != undefined ){
        _url= `${this.$store.state.app.activeGroup.v5ExamBaseUrl}/#/login/${this.examV5FormId}/0/0/${getToken()}`;
        window.location.replace(_url);
      }
    },
    modalNotification(mode) {
      if (
        hasOneOf(
          ["learningstudent", "crmclient", "learningoffice"],
          this.$store.state.user.access
        )
      ) {
        request({
          api: { method: "get", url: "learn/HasExamForMe" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            if (res.data.hasExam) {
              if(res.data.examV5!=undefined && res.data.examV5){
                this.examV5FormId= res.data.formId;
                this.examV5Modal=true;
              }else{
                let banExist = localRead(
                  `exam_${res.data.formId}_${res.data.courseId}_${this.$store.state.user.userId}_ban`
                );
                if (!banExist) {
                  this.goToExam.obj.courseId = res.data.courseId;
                  this.goToExam.obj.courseName = res.data.courseName;
                  this.goToExam.obj.formId = res.data.formId;
                  this.goToExam.obj.formName = res.data.formName;

                  this.goToExam.obj.startDate = res.data.startDate;
                  this.goToExam.obj.endDate = res.data.endDate;
                  this.goToExam.obj.questionCount = res.data.questionCount;

                  this.goToExam.modal = true;
                } else {
                  Notification.success({
                    message: "Өөр төхөөрөмжөөс таны өгөгдлийг татсан байна !",
                    title: "Амжилттай",
                    duration: 30000,
                    type: "success",
                    position: "top-right",
                    offset: 50,
                  });
                }
              }
            } else if (mode != undefined && mode == 1) {
              //shalgaltgui yed umnu shalgaltiin ilgeegeegui data bval ilgeeh code
              var iar = [];
              for (var i in localStorage) {
                if (i.includes("_filled")) {
                  iar.push(i);
                }
              }

              if (iar.length > 0) {
                request({
                  api: { method: "POST", url: "v2/learn/getFormFlag" },
                  data: {
                    id: iar[0].split("_")[1],
                  },
                  store: this.$store,
                }).then((res) => {
                  if (res != false && res.data.flag == 900) {
                    var _mdole = JSON.parse(localRead(iar[0]));
                    let filled = _mdole.map((x) => {
                      return {
                        qId: x.qId,
                        tAwrs: x.as,
                      };
                    });

                    let encrypted = this.encryptData(JSON.stringify(filled));

                    request({
                      api: {
                        method: "POST",
                        url: "V2/learn/PostExamFilledData",
                      },
                      data: {
                        model: {
                          examid: iar[0].split("_")[1],
                          finishedAt: 0,
                          userid: this.$store.state.user.userId,
                          encrypted: encrypted,
                          Questions: [],
                          finishByAuto: false,
                        },
                      },
                      store: this.$store,
                    }).then((res) => {
                      if (res != false) {
                        window.localStorage.removeItem(iar[0]);
                      }
                    });
                  }
                });
              }
            }
          }
        });

        if (
          (
            this.$store.state.user.userInfo.groupId == 9358 ||
            this.$store.state.user.userInfo.groupId == 9157 ||
            this.$store.state.user.userInfo.groupId == 9161 ||
            this.$store.state.user.userInfo.groupId == 1104 ||
            this.$store.state.user.userInfo.groupId == 9235 ||
            this.$store.state.user.userInfo.groupId == 9362 ||
            this.$store.state.user.userInfo.groupId == 9368 ||
            this.$store.state.user.userInfo.groupId == 9290 ||
            this.$store.state.user.userInfo.groupId == 9272 ||
            this.$store.state.user.userInfo.groupId == 9282 ||
            this.$store.state.user.userInfo.groupId == 9256 ||
            this.$store.state.user.userInfo.groupId == 9352) &&
          this.$store.state.app.activeForm.length == 0
        ) {
          request({
            api: { method: "get", url: "Form/GetFutureSharedFormList" },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              if (res.data.list.length > 0) {
                // console.log('GetFutureSharedFormList', res);
                this.handleActiveForm(res.data.list);
              }
            }
          });
        }
      }
    },
    makeid(length) {
      var result = [];
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    },
    encryptData(data) {
      CryptoJS.pad.NoPadding = { pad: function() {}, unpad: function() {} };
      let Pass = this.makeid(22);
      var text = data;
      var Salt = CryptoJS.enc.Utf8.parse("u2m9d2dfds1xS!2");
      var key128Bits1000Iterations = CryptoJS.PBKDF2(
        Pass.toString(CryptoJS.enc.Utf8),
        Salt,
        { keySize: 128 / 32, iterations: 1000 }
      );
      var iv = CryptoJS.enc.Hex.parse("e84ad660c4721ae0e84ad660c4721ae0");
      var encrypted = CryptoJS.AES.encrypt(text, key128Bits1000Iterations, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
      });
      return Pass + encrypted;
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },

    modalAlert() {
      if (this.$route.name != "examOnline") {
        request({
          api: {
            method: "get",
            url: "Content/GetLatestActiveGroupNotification",
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            let _tskId = res.data.taskId;
            //console.log('let _tskId', _tskId);
            if (_tskId > 0) {
              request({
                api: { method: "get", url: "task/taskInheritedDetail" },
                params: {
                  id: _tskId,
                },
                store: this.$store,
              }).then((res) => {
                this.alertObj.task = res.data.task;
                this.alertObj.modal = true;
                //console.log(this.alertObj.modal);
              });
            }
          }
        });
      }
    },
    checkTmxExam() {
      if (
        this.$store.state.app.activeGroup.id == 6126 &&
        localRead("tmz_exam") == 1 &&
        this.$route.name != "examOnline" &&
        this.$route.name == "lmsParticipant"
      ) {
        let _pid = 0;
        let prj = this.$store.state.app.groupDefaultProjects.filter(
          (x) => x.objectTypeId == parseInt(138, 10)
        );
        if (prj.length > 0) _pid = prj[0].id;

        request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
            id: this.$store.state.user.userInfo.profileId,
            objectTypeId: 138,
            parentId: 0,
            projectId: _pid,
            boxId: 0,
            userId: this.$store.state.user.userInfo.userId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.modalTmxExamObj = res.data.task;
            this.modalTmxExamObj.locTypeId4 = null;
            this.modalTmxExam = true;

            //modalTmxExamHide
          }
        });
      }
    },
    modalTmxExamObjSave() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      //this.modalTmxExamObj.locTypeId4= 81190;

      this.modalTmxExamObj.locTypeIds = [142047];

      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.modalTmxExamObj },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('res', res);
        if (res != false) {
          //console.log('this.modalTmxExamObj.locTypeId4', this.modalTmxExamObj.locTypeId4);
          Notification.success({
            title: "Амжилттай",
            message: `Мэдээлэл шинэчиллээ`,
            duration: 30000,
            position: "bottom-left",
          });
          window.localStorage.removeItem("tmz_exam");
          this.modalTmxExam = false;
        }
      });
    },
    locTypeId4Changed(e) {
      if (e > 0) {
        this.modalTmxExamHide = false;
      } else {
        this.modalTmxExamHide = true;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style>
i.feather {
  display: inline !important;
}
i.feather {
  height: 16px;
  width: 16px;
}
.nav-aside i.feather,
.lms-nav i.feather {
  height: auto;
  width: auto;
}

svg.feather__content {
  display: inline-block !important;
}

.withicon .navbar-menu .nav-link svg {
  display: block;
  padding-right: 2px;
  margin-right: 5px;
  margin-top: -3px;
}
@media (min-width: 1200px) {
  .navbar-header .navbar-right {
    width: 440px !important;
  }
}

.aside-menu-link i {
  width: 18px;
  height: 18px;
  stroke-width: 2.5px;
  margin-top: -3px;
}

.show-aside .aside-menu-link i:first-child {
  display: none;
}
.show-aside .aside-menu-link i:last-child {
  display: block;
}

.is-dark .navbar-brand {
  color: #97a3b9;
}
.chng-skin {
  position: absolute;
  right: 10px;
  top: 15px;
}

.is-dark .chng-skin {
  color: #97a3b9 !important;
}

/* .navbar-header-fixed{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
} */

.dynamic-app .locker-loader {
  display: none;
}
.dynamic-app.dynamic-locker .locker-loader {
  display: block;
}
.locker-loader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: hsla(0, 0%, 100%, 0.5) !important;
  backdrop-filter: blur(1px);
  z-index: 9999;
  top: 0;
  left: 0;
  text-align: center;
}
.locker-main {
  color: white;
  border-radius: 0 0 5px 5px;
  padding: 5px;
  width: 10vw;
  margin: 0 auto;
  background: orange;
}

.my-autocomplete {
  width: 400px !important;
}
.my-autocomplete li {
  line-height: normal;
  padding: 7px;
  border-bottom: 1px solid rgba(72, 94, 144, 0.16);
}
.my-autocomplete li .value {
  text-overflow: ellipsis;
  overflow: hidden;
}
.my-autocomplete li .link {
  font-size: 12px;
  color: #b4b4b4;
}
.zaawar .carousel-caption {
  background: rgb(0 0 0 / 80%);
  right: 0;
  left: 0;
  widows: 100%;
}
.iosTutorial {
  height: 100vh;
  position: absolute;
  top: 0;
  width: 100%;
  /* border: 0; */
  z-index: 999;
  background: white;
}
.iosClose {
  left: 40%;
  position: fixed;
  bottom: 20px;
  z-index: 999;
}
</style>
